import '../app-navigator';

describe('app-navigator', () => {
  it('Expect custom element <app-navigator /> is defined', () => {
    const el = customElements.get('app-navigator');
    expect(el).toBeDefined();
  });
});
